import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserModel} from './user.model';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class UserService {

  private userSource = new BehaviorSubject<UserModel>(new UserModel());
  currentUser = this.userSource.asObservable();

  constructor(private http: HttpClient) {

  }

  getMe(): Observable<UserModel> { /* apipncinvest.co.kr/ */
    return this.http.get<UserModel>('//api.feelwaypawnshop.com/api/me', {});
  }

  init(): void {
    this.http.get<UserModel>('//api.feelwaypawnshop.com/api/me', {}).subscribe(user => {
      this.userSource.next(user);
    });
  }

  setMe(user: UserModel): void {
    this.userSource.next(user);
  }


}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/user.service.ts